<nav class="breadcrumb" aria-label="Breadcrumb">
  @for (crumb of crumbs(); track crumb.label; let i = $index) {
    @if (i > 0) {
      <span class="breadcrumb__sep" aria-hidden="true">
        <kc-icon iconClass="chevron-right" size="xxs" />
      </span>
    }
    @if (crumb.isCurrent) {
      <b class="breadcrumb__current" aria-current="page">{{ crumb.label }}</b>
    } @else {
      <span class="breadcrumb__parent">{{ crumb.label }}</span>
    }
  }
</nav>
